import Axios from 'axios';
import React, {useState} from 'react'

const GetInTouch = () => {
    const [contactList, setContactList] = useState([]);
    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const addContact = () => {
    Axios.post('http://localhost:3001/create', {
    name:name, phone:phone, email:email
      }).then(() => {
        setContactList([
          ...contactList, {
            name:name,
            phone:phone,
            email:email,
          },
     ]);
    });
    };
        
  return (
    <div>
    <label>Name:</label>
    <input type="text"
    onChange={(e) => {
      setName(e.target.value);
    }}
    />
    <label>Phone:</label>
    <input type="text"  onChange={(e) => {
      setPhone(e.target.value);
    }}/>
     <label>Email:</label>
     <input type="text"  onChange={(e) => {
      setEmail(e.target.value);
    }}/>
    <button onClick={addContact} type='submit'>Submit</button>

    
    </div>
    )
}

export default GetInTouch;
//    <button onClick={addContact} type="submit" value="Submit">Submit</button>
